/**
 * Created by joerg on 20.05.17.
 */

import {observable,computed, runInAction} from 'mobx';
import shortid from 'shortid'
import SelectionOptionModel from './SelectionOptionModel'
import Utils from '../utils/Utils'

export default class SelectionModel {
    @observable title;
    @observable selectedOption;
    @observable options;
    @observable einheit;
    @observable disabled;
    key;
    selectCB
    @computed get value(){
        return (this.selectedOption) ? this.selectedOption.value : -11;
    }

    constructor(title = "", options = [], selectedIndex = -1, einheit = "", disabled = false, onChange = null) {
        this.title = title;
        this.options = options;
        this.selectedOption = (options.length > 0 && options.length-1 >= selectedIndex)?options[selectedIndex]:undefined;

        this.einheit = einheit;
        this.disabled = disabled;
        this.key = shortid.generate()
        this.selectCB = onChange
    }

    setOptions(options = [], selectedIndex = -1){
        this.options = options
        this.selectedOption = (options.length > 0 && options.length-1 >= selectedIndex)?options[selectedIndex]:undefined;

    }

    onSelect = item => {
        this.selectedOption = this.options.filter(o => o.key === item.key)[0];
        if(this.selectCB){
            runInAction(() => {
                this.selectCB(this.selectedOption)
            })
        }
    }

    getCombinedVal() {
        return  Utils.stripTags(this.selectedOption.title.toString()) //+ ' ' + (this.selectedOption.einheit === undefined)?'': this.selectedOption.einheit;
    }
    getTitleStripped(){
        return Utils.stripTags(this.title);
    }





    static createOptionsFromObjectArray(os = []){
       Utils.polyfillArray();
       return Array.from(os,o => new SelectionOptionModel(o.title,o.value,o.einheit,o.disabled));


    }
}


// WEBPACK FOOTER //
// ./src/models/SelectionModel.js